'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { UserDetailHeader } from './-components/UserDetailHeader';
export const Route = createFileRoute('/_staff/users/$userId/_layout')({
  component: Layout
});
function Layout() {
  return <div className="flex h-full flex-col">
      <UserDetailHeader />
      <div className="relative min-h-0 flex-1 overflow-auto">
        <Suspense>
          <Outlet />
        </Suspense>
      </div>
    </div>;
}